import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const linesFields: FieldInterface[] = [
  {
    key: 'createdAt',
    originKey: 'created_at',
    type: FIELD_TYPES.date,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'currency',
    originKey: 'currency',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'investmentName',
    originKey: 'investment_name',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'isin',
    originKey: 'isin',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'operationDate',
    originKey: 'operation_date',
    type: FIELD_TYPES.date,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'updatedAt',
    originKey: 'updated_at',
    type: FIELD_TYPES.date,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'parts',
    originKey: 'parts',
    type: FIELD_TYPES.integer,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'price',
    originKey: 'price',
    type: FIELD_TYPES.integer,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'share',
    originKey: 'share',
    type: FIELD_TYPES.integer,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'valuation',
    originKey: 'valuation',
    type: FIELD_TYPES.integer,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'diciUrl',
    originKey: 'investment_dici_url',
    type: FIELD_TYPES.string,
  },
  {
    key: 'managementType',
    originKey: 'management_type',
    type: FIELD_TYPES.string,
    enumType: 'ApiPortfolioManagementModes',
    enumTypePath: 'src/tpbp-json-api-handler/models/contract/contract.types.ts',
  },
]

const linesRelations: RelationInterface[] = [
  {
    key: '_relations',
    originKey: 'relations',
    objectType: OBJECT_TYPES.relation,
    isMultiple: true,
  },
  {
    key: '_investment',
    originKey: 'investment',
    objectType: OBJECT_TYPES.relation,
  },
  {
    key: '_portfolios',
    originKey: 'portfolios',
    objectType: OBJECT_TYPES.portfolio,
    isMultiple: true,
  },
]

export { linesFields, linesRelations }
